import { useState, useEffect, useRef } from 'react';
import client from '../sanityClient';

const useGameboy = (pages, projectList, setProjectList) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedProjectIndex, setSelectedProjectIndex] = useState(0);
  const [inPage, setInPage] = useState(false);
  const [viewingProjectDetails, setViewingProjectDetails] = useState(false);
  const projectItemRefs = useRef([]);
  const detailContentRef = useRef(null);

  const fetchProjects = () => {
    client
      .fetch(`*[_type == "project"] | order(_createdAt desc)`)
      .then((data) => {
        setProjectList(data);
        setSelectedProjectIndex(0);
        setViewingProjectDetails(false);
      })
      .catch(console.error);
  };

  return {
    selectedIndex,
    setSelectedIndex,
    selectedProjectIndex,
    setSelectedProjectIndex,
    inPage,
    setInPage,
    viewingProjectDetails,
    setViewingProjectDetails,
    projectItemRefs,
    detailContentRef,
    fetchProjects,
  };
};

export default useGameboy;